/* unplugin-vue-components disabled */import { render } from "./TransferSTFIL.vue?vue&type=template&id=1cd122fa&scoped=true"
import script from "./TransferSTFIL.vue?vue&type=script&lang=js"
export * from "./TransferSTFIL.vue?vue&type=script&lang=js"

import "./TransferSTFIL.vue?vue&type=style&index=0&id=1cd122fa&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd122fa"]])

export default __exports__